// import { message } from 'antd';
import { get } from 'lodash';
import {
  fetchGoodsList,
  fetchCheckInClients,
  getOrderDetail,
  getStoreStorageSetting,
} from '@/api/goods';
import { Igoods } from '@/pages/goods/type';
import actionType from './actionType';

export const initState = () => {
  return {
    type: actionType.INIT_STATE,
  };
};

export const updateState = (state) => {
  return {
    type: actionType.UPDATE_GOODS_STATE,
    payload: state,
  };
};

export const updateBuyWay = (state) => {
  return {
    type: actionType.UPDATE_BUY_WAY,
    payload: state,
  };
};

// 更新搜索项
export const updateSearchParams = (field, value) => {
  return {
    type: actionType.UPDATE_SEARCH_PARAM,
    payload: { field, value },
  };
};

// 获取门店仓库扣除配置
export const getStorageSetting = () => {
  return async (dispatch) => {
    dispatch(updateState({ getStorageTypeLoading: true }));
    try {
      const res = (await getStoreStorageSetting()) || {};
      if (res.code === 0) {
        const data = get(res, 'data', []);

        dispatch({
          type: actionType.GET_STORAGE_CONFIG,
          payload: {
            storageType: data?.storageType,
          },
        });
      }
      dispatch(updateState({ getStorageTypeLoading: false }));
    } catch (error) {
      dispatch(updateState({ getStorageTypeLoading: false }));
    }
  };
};

// 获取商品列表
export const getGoodsList = (params) => {
  return async (dispatch) => {
    dispatch(updateState({ saleGoodsLoading: true }));
    try {
      const res = (await fetchGoodsList(params)) || {};
      if (res.code === 0) {
        const data = get(res, 'data', []);
        const copy = data ? JSON.stringify(data) : JSON.stringify([]);

        dispatch({
          type: actionType.GOODS_LIST,
          payload: {
            saleGoodsList: JSON.parse(copy) || [],
            saleGoodsListCopy: JSON.parse(copy) || [],
          },
        });
      }
      dispatch(updateState({ saleGoodsLoading: false }));
    } catch (error) {
      dispatch(updateState({ saleGoodsLoading: false }));
    }
  };
};

// 加入一个商品到购物车
export const addToCart = (goodsItem: Igoods, index: number) => {
  return (dispatch, getState) => {
    const { cartList, cartTotalNum, saleGoodsList, storageType } = getState().goods;
    const { skuCode } = goodsItem || {};
    // 购物车中是否存在该商品
    if (cartList.get(skuCode)) {
      // 更新购物车列表数量
      const cartNum = cartList.get(skuCode).cartNum + 1;
      cartList.set(skuCode, { ...goodsItem, index, cartNum });
    } else {
      // 更新购物车列表商品
      cartList.set(skuCode, { ...goodsItem, index, cartNum: 1 });
    }
    // 更新选购商品列表库存数目
    // eslint-disable-next-line operator-assignment
    if (storageType === 2) saleGoodsList[index].qty = saleGoodsList[index].qty - 1;
    // eslint-disable-next-line operator-assignment
    if (storageType === 1) saleGoodsList[index].storageQty = saleGoodsList[index].storageQty - 1;
    dispatch({
      type: actionType.ADD_GOODS_TO_CART,
      payload: {
        cartList,
        saleGoodsList,
        cartTotalNum: cartTotalNum + 1,
      },
    });
  };
};

// 从购物车中减少一个商品
export const reduceFromCart = (goodsItem: Igoods, index: number) => {
  return (dispatch, getState) => {
    const { cartList, cartTotalNum, saleGoodsList, storageType } = getState().goods;
    const { skuCode } = goodsItem || {};
    if (cartList.get(skuCode)) {
      // 更新购物车列表数量
      const cartNum = cartList.get(skuCode).cartNum - 1;
      // 如果购物车的数量减到0 就从购物车中删除
      if (cartNum === 0) {
        cartList.delete(skuCode);
      } else {
        cartList.set(skuCode, { ...goodsItem, index, cartNum });
      }
    }
    // 更新选购商品列表库存数目
    // eslint-disable-next-line operator-assignment
    if (storageType === 2) saleGoodsList[index].qty = saleGoodsList[index].qty + 1;
    // eslint-disable-next-line operator-assignment
    if (storageType === 1) saleGoodsList[index].storageQty = saleGoodsList[index].storageQty + 1;
    dispatch({
      type: actionType.ADD_GOODS_TO_CART,
      payload: {
        cartList,
        saleGoodsList,
        cartTotalNum: cartTotalNum - 1,
      },
    });
  };
};

// 改变购物车商品的数量
export const changeCartNum = (goodsItem: Igoods, index: number, number: number) => {
  return (dispatch, getState) => {
    const {
      cartList,
      cartTotalNum,
      saleGoodsList,
      saleGoodsListCopy,
      storageType,
    } = getState().goods;
    const { skuCode } = goodsItem || {};
    // 更新购物车列表数量
    const cartNum = number;
    // 如果购物车的数量减到0 就从购物车中删除
    if (cartNum === 0) {
      cartList.delete(skuCode);
    } else {
      cartList.set(skuCode, { ...goodsItem, index, cartNum });
    }
    // 更新选购商品列表库存数目
    // eslint-disable-next-line operator-assignment
    if (storageType === 2) {
      const initialQty = saleGoodsListCopy[index].qty;
      // eslint-disable-next-line operator-assignment
      saleGoodsList[index].qty = initialQty - cartNum;
    }
    if (storageType === 1) {
      const initialQty = saleGoodsListCopy[index].storageQty;
      // eslint-disable-next-line operator-assignment
      saleGoodsList[index].storageQty = initialQty - cartNum;
    }
    // // eslint-disable-next-line operator-assignment
    // if (storageType === 1) saleGoodsList[index].storageQty = saleGoodsList[index].storageQty + 1;

    dispatch({
      type: actionType.ADD_GOODS_TO_CART,
      payload: {
        cartList,
        saleGoodsList,
        cartTotalNum: cartTotalNum + cartNum,
      },
    });
  };
};

// 删除购物车中某个商品
export const deleteOneCartGoods = (goodsItem: Igoods) => {
  return (dispatch, getState) => {
    const { cartList, cartTotalNum, saleGoodsList } = getState().goods;
    const { skuCode } = goodsItem || {};
    const { cartNum, index } = cartList.get(skuCode);

    // eslint-disable-next-line operator-assignment
    saleGoodsList[index].qty = saleGoodsList[index].qty + cartNum;
    cartList.delete(skuCode);

    dispatch({
      type: actionType.ADD_GOODS_TO_CART,
      payload: {
        cartList,
        cartTotalNum: cartTotalNum - cartNum,
      },
    });
  };
};

// 删除购物车中所有商品
export const deleteAllCartGoods = () => {
  return (dispatch, getState) => {
    const { cartList, saleGoodsListCopy } = getState().goods;

    // 清除所有成员
    cartList.clear();

    const copy = JSON.stringify(saleGoodsListCopy);
    const list = JSON.parse(copy);

    dispatch({
      type: actionType.ADD_GOODS_TO_CART,
      payload: {
        cartList,
        saleGoodsList: list,
        cartTotalNum: 0,
      },
    });
  };
};

// 通过roomId找到该房间相关单号等及信息
// const findRoomInfosByRoomId = (roomId: any, data: any) => {
//   const BUY_WAY = {
//     recNo: '',
//     resvNo: '',
//     roomId: 0,
//     roomNo: '',
//   };
//   if (data && data.length > 0) {
//     data.map((item) => {
//       if (item.roomId === roomId) {
//         BUY_WAY.recNo = item.recNo || '';
//         BUY_WAY.resvNo = item.resvNo || '';
//         BUY_WAY.roomId = item.roomId || 0;
//         BUY_WAY.roomNo = item.roomNo || '';
//       }
//       return item;
//     });
//   }

//   return BUY_WAY;
// };

// 获取已入住客户信息 (isFixedRoom: boolean, queryInfo: any)
export const getClientList = () => {
  return async (dispatch) => {
    dispatch(updateState({ clientListLoading: true }));
    try {
      const res = (await fetchCheckInClients()) || {};
      if (res.code === 0) {
        const data = get(res, 'data', []);

        dispatch({
          type: actionType.CLIENT_LIST,
          payload: {
            clientList: data,
          },
        });
      }
      dispatch(updateState({ clientListLoading: false }));
    } catch (error) {
      dispatch(updateState({ clientListLoading: false }));
    }
  };
};

// 获取已入住客户信息
export const getOrderInfos = (orderNo: string) => {
  return async (dispatch, getState) => {
    dispatch(updateState({ settleLoading: true }));
    try {
      const { buyWay } = getState().goods;
      const res = (await getOrderDetail(orderNo)) || {};
      if (res.code === 0) {
        const data = get(res, 'data', {});
        const {
          details = [],
          totalPricePayable = 0,
          totalActualPrice = 0,
          totalCount = 0,
          saleType,
        } = data;

        dispatch({
          type: actionType.CLIENT_LIST,
          payload: {
            settleGoodsList: details || [],
            settleTotalCount: totalCount,
            settleTotalActualPrice: totalPricePayable,
            actualPay: totalActualPrice,
            buyWay: {
              ...buyWay,
              saleType,
            },
          },
        });
      }
      dispatch(updateState({ settleLoading: false }));
    } catch (error) {
      dispatch(updateState({ settleLoading: false }));
    }
  };
};
